import { UPDATE_MODE } from "../actions/mode"

const mode = (state, action) => {

    if (!state) {
        state = { mode: "convert" };
        const sessionMode = window.sessionStorage.getItem('mode');
        if (sessionMode) state.mode = JSON.parse(sessionMode);
    }

    switch (action.type) {
        case UPDATE_MODE:
            window.sessionStorage.setItem('mode', JSON.stringify(action.mode));
            return Object.assign({}, state, { mode: action.mode })
        default:
            return state;
    }
}

export default mode;
